import React from "react";
import "./Ceodb.scss";

const TrendPreview = () => {
    return (
        <div className="trend-preview">

            {/* FILTER BAR */}
            <div className="trend-filter">
                <div className="left">
                    <label>Select Dimension:</label>
                    <select>
                        <option>Respect</option>
                        <option>Credibility</option>
                    </select>
                </div>

                <div className="right">
                    <select>
                        <option>Monthly</option>
                        <option>Weekly</option>
                    </select>
                </div>
            </div>

            {/* TABLE */}
            <div className="trend-table">

                {/* HEADER */}
                <div className="trend-row header">
                    <div className="col name">Dimension with statement</div>
                    <div className="col">January<br />2026</div>
                    <div className="col">December<br />2025</div>
                    <div className="col">November<br />2025</div>
                    <div className="col">October<br />2025</div>
                </div>

                {/* DIMENSION ROW */}
                <div className="trend-row dimension">
                    <div className="col name">Respect</div>
                    <div className="col score">44</div>
                    <div className="col score">43</div>
                    <div className="col score">44</div>
                    <div className="col score">50</div>
                </div>

                {/* STATEMENT ROWS */}
                <div className="trend-row statement">
                    <div className="col name">
                        I am able to take time off from work when I think it's necessary.
                    </div>
                    <div className="col score">35</div>
                    <div className="col score">45</div>
                    <div className="col score">40</div>
                    <div className="col score">47</div>
                </div>

                <div className="trend-row statement">
                    <div className="col name">
                        People here are treated fairly regardless of their gender.
                    </div>
                    <div className="col score">52</div>
                    <div className="col score">41</div>
                    <div className="col score">48</div>
                    <div className="col score">53</div>
                </div>

            </div>
        </div>
    );
};

export default TrendPreview;